<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="addressListGetter" :filter="filterForDropdown"
    :min-search-char-limit="0" :items-per-page="500" :externaledit="externaledit" :clearable="clearable"
    :disabled="isDisabled" :loading="loading" valuekey="Id" textkey="MetaString"
    :label="label || $t('servicesystem.common_objects.address.address')"
    :placeholder="placeholder || $t('servicesystem.common_objects.address.search_field_label')" :singleline="singleline"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">
    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="18">mdi-map-marker</v-icon>
    </template>

    <template v-slot:selection="{ item }">
      <div class="nowrapheader" style="max-width: 100%;">
        <span v-if="item.Name" class="pr-1">{{ item.Name }}</span>
        <span class="text--secondary" style="font-size: 0.9em;">
          {{ getAddressLine(item) }}
        </span>
      </div>
    </template>

    <template v-slot:item-content="{ item }">
      <AddressListItem :item="item" class="ml-n3">
      </AddressListItem>
    </template>

  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";
import AddressListItem from "@/components/ListItems/AddressListItem.vue";

function buildMetaString(addr) {
  if (!addr) return "";
  const parts = [addr.Id, addr.Name, addr.Street, addr.Zip, addr.City, addr.Country].filter(
    (p) => p != null && p !== ""
  );
  return parts.join(" ");
}

export default {
  name: "CustomerDeliveryAddressSelect",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Number, String, Object],
    customerId: [String, Number],
    existingAddress: Object,
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    singleline: Boolean,
    externaledit: Boolean,
    hideIcon: Boolean,
    hideCustomerDefaultAddress: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
    AddressListItem,
  },
  mixins: [clientAPI, rules],

  computed: {
    filterForDropdown() {
      return {
        customerId: this.customerId,
        existingAddress: this.existingAddress,
      };
    },
    isDisabled() {
      return !!this.disabled || !this.customerId;
    },
  },

  methods: {
    getAddressLine(addr) {
      if (!addr) return "";
      return [addr.Street, addr.Zip, addr.City, addr.Country].filter((p) => p != null && p !== "").join(", ");
    },

    async addressListGetter(filterDto /*, _cancelationToken*/) {
      const cid = filterDto?.customerId;
      if (!cid) return [];

      // Address API returns all items; avoid duplicating when QPaginatedSearchDropdown requests page 2+
      if ((filterDto?.Page || 1) > 1) return [];

      let list = [];
      try {
        list = await this.getCustomerAdressesByCustomerId(cid) || [];
      } catch (e) {
        console.error("CustomerDeliveryAddressSelect addressListGetter error", e);
        return [];
      }

      if (this.hideCustomerDefaultAddress) {
        list = list.filter(x => !x.Id.startsWith('-'));
      }

      const existing = filterDto?.existingAddress;
      if (existing && existing.Id != null) {
        const exists = list.some((a) => String(a.Id) === String(existing.Id));
        if (!exists) {
          const addr = { ...existing };
          addr.MetaString = addr.MetaString || buildMetaString(addr);
          list = [addr, ...list];
        }
      }

      const sw = (filterDto?.SearchWord || "").trim();
      if (sw) {
        list = list.filter((a) => (a.MetaString || "").toLowerCase().includes(sw.toLowerCase()));
      }

      return list;
    },
  },
};
</script>


<style lang="scss" scoped>
.nowrapheader {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
